import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageCardsServiceService } from '../credit-card-management/manage-cards-service.service';

@Component({
  selector: 'app-xicard-flow-dialog-component',
  templateUrl: './xicard-flow-dialog-component.component.html',
  styleUrls: ['./xicard-flow-dialog-component.component.scss'],
})
export class XicardFlowDialogComponentComponent implements OnInit {

  @Input() data;
  paymentDone = false;
  loading = false;
  paymentResp;
  paymentErrorResp;
  cvvNo = '';
  allowedKeysToDisplay = ['AuthorizationDate', 'Message', 'TransactionID'];
  
  constructor(
    private manageCardsService: ManageCardsServiceService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() { }

  doPayment() {
    const selectedCard = this.data.payData.payModel.bank;
    this.loading = true;
    this.manageCardsService.doPayment(selectedCard, this.data.amt).subscribe(data => {
      this.paymentDone = true;
      this.loading = false;
      if (data.success) {
        this.paymentResp = Object.keys(data.resp).map((key) => {
          return {key, data: data.resp[key][0]};
        })
      } else {
        this.paymentErrorResp = data;
      }
    }, () => {
      this.loading = false;
    });
  }


}
